import { render, staticRenderFns } from "./VuesticFeed.vue?vue&type=template&id=4d7fd8ec"
import script from "./VuesticFeed.vue?vue&type=script&lang=js"
export * from "./VuesticFeed.vue?vue&type=script&lang=js"
import style0 from "./VuesticFeed.vue?vue&type=style&index=0&id=4d7fd8ec&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d7fd8ec')) {
      api.createRecord('4d7fd8ec', component.options)
    } else {
      api.reload('4d7fd8ec', component.options)
    }
    module.hot.accept("./VuesticFeed.vue?vue&type=template&id=4d7fd8ec", function () {
      api.rerender('4d7fd8ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-feed/VuesticFeed.vue"
export default component.exports